
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"#4EAA3F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.572 12a5.428 5.428 0 1110.856 0 5.428 5.428 0 01-10.856 0zM12 5.372a6.628 6.628 0 100 13.256 6.628 6.628 0 000-13.256zm.6 3.279a.6.6 0 00-1.2 0V12a.6.6 0 00.176.424l2.01 2.01a.6.6 0 00.848-.849L12.6 11.751v-3.1z","fill":"#fff"}})])
          )
        }
      }
    